var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.627,
    height: 22.627,
    viewBox: "0 0 22.627 22.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_add_circle_outline_24px",
    d: "M10.8,6H9.2V9.2H6v1.6H9.2V14h1.6V10.8H14V9.2H10.8ZM10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm0,14.4A6.4,6.4,0,1,1,16.4,10,6.408,6.408,0,0,1,10,16.4Z",
    transform: "translate(11.314 -2.828) rotate(45)",
    fill: "#ca4927"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/fail-icon.80315dd6850bc4e1595d0f976203c148.svg";
export { ForwardRef as ReactComponent };